import React, { Suspense, useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import withAuthLayout from "./HoC/withAuthLayout";
import { Provider } from "react-redux";
import store from "./components/redux/store";
import Customer from "./pages/CustomerSupport/containers/Customer";
import SaleOrder from "./pages/CustomerSupport/containers/SaleOrder";
import Incoterms from "./pages/Setting/containers/Incoterms";
import Transshipment from "./pages/Setting/containers/Transshipment";
import Terminal from "./pages/Setting/containers/Terminal";
import Depots from "./pages/Setting/containers/Depots";
import EditFreightTerms from "./pages/Setting/containers/EditFreightTerms";
import EditTransshipment from "./pages/Setting/containers/EditTransshipment";
import EditDepots from "./pages/Setting/containers/EditDepots";
// import EditSaleOrder from "./pages/CustomerSupport/containers/EditSaleOrder";
import EditTerminal from "./pages/Setting/containers/EditTerminal";
import EditPolPod from "./pages/Setting/containers/EditPolPod";
import AddCustomer from "./pages/CustomerSupport/containers/AddCustomer";
import AddPolPod from "./pages/Setting/containers/AddPolPod";
import AddIncoTerms from "./pages/Setting/containers/AddIncoTerms";
import AddTransshipment from "./pages/Setting/containers/AddTransshipment";
import AddDepots from "./pages/Setting/containers/AddDepots";
import AddTerminal from "./pages/Setting/containers/AddTerminal";
import PolPod from "./pages/Setting/containers/PolPod";
import Login from "./pages/login/login";
import containerPage from "./pages/Setting/containers/containerPage";
import EditCustomer from "./pages/CustomerSupport/containers/EditCustomer";
import EditContainer from "./pages/Setting/containers/EditContainer";
import Vehicle from "./pages/Setting/containers/Vehicle";
import EditVehicle from "./pages/Setting/containers/EditVehicle";
import Liners from "./pages/Setting/containers/Liners";
import EditLiners from "./pages/Setting/containers/EditLiners";
import FreightForwarder from "./pages/Setting/containers/FreightForwarder";
import EditFreightForwarder from "./pages/Setting/containers/EditFreightForwarder";
import EditCommodity from "./pages/Setting/containers/EditCommodity";
import Commodity from "./pages/Setting/containers/Commodity";
import Quotation from "./pages/CustomerSupport/containers/Quotation";
import EditQuotation from "./pages/CustomerSupport/containers/EditQuotation";
import AddSaleOrder from "./pages/CustomerSupport/containers/AddSaleOrder";
import ContainerList from "./pages/Planner/containers/ContainerList";
import AddContainerList from "./pages/Planner/containers/AddContainerList";
import ShipSchedule from "./pages/Planner/containers/ShipSchedule";
import EditShipSchedule from "./pages/Planner/containers/EditShipSchedule";
import Planning from "./pages/Planner/containers/Planning";
import Company from "./pages/Setting/containers/Company";
import AddCompany from "./pages/Setting/containers/AddCompany";
import EditCompany from "./pages/Setting/containers/EditCompany";
import Employee from "./pages/Setting/containers/Employee";
import Transport from "./pages/Setting/containers/Transport";
import AddTransport from "./pages/Setting/containers/AddTransport";
import Branch from "./pages/Setting/containers/Branch";
import AddBranch from "./pages/Setting/containers/AddBranch";
import EditBranch from "./pages/Setting/containers/EditBranch";
import ReportAdvancePayment from "./pages/Report/containers/ReportAdvancePayment";
import AddEmployee from "./pages/Setting/containers/AddEmployee";
import EditEmployee from "./pages/Setting/containers/EditEmployee";
import EditTransport from "./pages/Setting/containers/EditTransport";
import ServiceList from "./pages/Setting/containers/ServiceList";
import EditService from "./pages/Setting/containers/EditService";
import Factory from "./pages/CustomerSupport/containers/Factory";
import AddFactory from "./pages/CustomerSupport/containers/AddFactory";
import EditFactory from "./pages/CustomerSupport/containers/EditFactory";
import Hightofwater from "./pages/Ship/containers/Hightofwater";
import Tuglist from "./pages/Setting/containers/Tuglist";
import Edittug from "./pages/Setting/containers/EditTug";
import FreightTerms from "./pages/Setting/containers/FreightTerms";
import AddFreightTerms from "./pages/Setting/containers/AddFreightTerms";
import EditIcoTerms from "./pages/Setting/containers/EditIcoTerms";
import AddPackage from "./pages/Setting/containers/Editpackage";
import Package from "./pages/Setting/containers/Package";
import Currency from "./pages/Setting/containers/Cerrency";
import EditCurrency from "./pages/Setting/containers/EditCerrency";
import Country from "./pages/Setting/containers/Country";
import EditCountry from "./pages/Setting/containers/EditCountry";
import TrainRoute from "./pages/Setting/containers/TrainRoute";
import { useHistory } from "react-router-dom";
import httpClientInstants from "./libs/utils/HttpClient";
import envInstants from "./libs/configs/env";
import { setDefaultURL } from "./components/services/api";
import WorkOrder from "./pages/Truck/containers/WorkOrder";
import TruckSchedule from "./pages/Truck/containers/TruckSchedule";
import ViewTruckSchedule from "./pages/Truck/containers/ViewTruckSchedule";
import TrainScheduleList from "./pages/Planner/containers/TrainScheduleList";
import EditTrainSchedule from "./pages/Planner/containers/EditTrainSchedule";
import EditWorkOrder from "./pages/Truck/containers/EditWorkOrder";
import Forwarding from "./pages/CustomerSupport/containers/Forwarding";
import EIR from "./pages/Truck/containers/EIR";
import EIR_Detail from "./pages/Truck/containers/EIR_Detail";
import ContainerListTruck from "./pages/Truck/containers/ContainerListTruck";
import ContainerListShip from "./pages/Ship/containers/ContainerListShip";
import ContainerListTrain from "./pages/Train/containers/ContainerListTrain";
import CyShip from "./pages/Ship/containers/CyShip";
import Cy from "./pages/Ship/containers/Cy";
import ContainerTALLYList from "./pages/Ship/containers/ContainerTALLYList";
import TallyDetail from "./pages/Ship/containers/TallyDetail";
import TrainTallyDetail from "./pages/Train/containers/TallyDetail";
import RepairList from "./pages/ContainerRepair/containers/RepairList";
import RepairEditAndCreate from "./pages/ContainerRepair/containers/RepairEditAndCreate";
import Dashboard from "./pages/Dashboard/containers/Dashboard";
import DashboardFinancial from "./pages/Financial/containers/Dashboard";
import ExpenseList from "./pages/Financial/containers/ExpenseList";
import AddExpense from "./pages/Financial/containers/AddExpense";
import PaymentList from "./pages/Financial/containers/PaymentList";
import SideBar from "./components/Sidebar/sideBar";
import ManagePermissions from "./pages/permissions/ManagePermissions";
import SetPermissions from "./pages/permissions/SetPermissions";
import Role from "./pages/permissions/Role";
import AddTrainroute from "./pages/Setting/containers/AddTrainroute";
import Barge from "./pages/Setting/containers/BargeList";
import EditBarge from "./pages/Setting/containers/EditBarge";
import EditTrainroute from "./pages/Setting/containers/EditTrainroute";
import DetailPayment from "./pages/Financial/containers/DetailPayment";
import { createGenerateClassName } from "@mui/styles";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import EditSaleOrder from "./pages/CustomerSupport/containers/EditSaleOrder";
import QuotationReport from "./pages/ReportPage/Quotation";
import SaleOrderReport from "./pages/ReportPage/SaleOrder";
import ContainerManagementReport from "./pages/ReportPage/ContainerManagement";
import BookingConfirmationReport from "./pages/ReportPage/BookingConfirmation";
import ContainerListLoadingReport from "./pages/ReportPage/ContainerListLoading";
import BookingDetailsReceivedReport from "./pages/ReportPage/BookingDetailsReceived";
import ContainerListReport from "./pages/ReportPage/ContainerList";
import CargoReceiptReport from "./pages/ReportPage/CargoReceipt";
import EIRReport from "./pages/ReportPage/EIR";
import EIR_SaleorderReport from "./pages/ReportPage/EIR_saleorder";
import ReportExpense from "./pages/Report/containers/ReportExpense";
import EditSaleOrderOld from "./pages/CustomerSupport/containers/EditSaleOrderOld";
import AddLocation from "./pages/Setting/containers/AddLocation";
import EditLocation from "./pages/Setting/containers/EditLocation";
import LocationList from "./pages/Setting/containers/LocationList";
import Report from "./pages/Report/containers";
import ReportEmpty from "./pages/Report/containers/ReportEmpty";
import ReportLaden from "./pages/Report/containers/ReportLaden";
import Costlist from "./pages/Setting/containers/Costlist";
import EditCost from "./pages/Setting/containers/EditCost";
import Cost from "./pages/Ship/containers/Cost";
import TrainCost from "./pages/Train/containers/Cost";
import SaleOrderCostReport from "./pages/Report/containers/SaleOrderCostReport";
import ShipCostReport from "./pages/Report/containers/ShipCostReport";
import TrainCostReport from "./pages/Report/containers/TrainCostReport";
import Add_EIR from "./pages/Truck/containers/Add_EIR";
import ReportRevenue from "./pages/Report/containers/ReportRevenue";
import ShipPlanning from './pages/Planner/containers/ShipPlanning'
import TrainPlanning from './pages/Planner/containers/TrainPlanning'
import TruckPlanning from './pages/Planner/containers/TruckPlanning'
import Detail_EIR from "./pages/Truck/containers/Detail_EIR";
import Inbound from "./pages/Ship/containers/Inbound";
import EditInbound from "./pages/Ship/containers/Editinbound/EditInbound";
import Outbound from "./pages/Ship/containers/Outbound";
import Plan from "./pages/Ship/containers/Plan";
import TrainPlan from "./pages/Train/containers/Plan";
import Stock from "./pages/Planner/containers/Stock";
import ViewStock from "./pages/Planner/containers/ViewStock";
import EditOutbound from "./pages/Ship/containers/Editoutbound/Editoutbound";
import Inboundtrain from "./pages/Train/containers/Inboundtrain";
import EditInboundtrain from "./pages/Train/containers/EditInbound";
import EditOutboundtrain from "./pages/Train/containers/EditOutbound";
import RepairDD from "./pages/ContainerRepair/containers/detailrepair";
import InboundTruck from "./pages/Truck/containers/InboundTruck";
import EditInboundtruck from "./pages/Truck/containers/EditBound";
import EditOutboundtruck from "./pages/Truck/containers/EditBound";
import Outboundtrain from "./pages/Train/containers/Outboundtrain";
import OutboundTruck from "./pages/Truck/containers/OutboundTruck";
import DetailWorkOrder from "./pages/Truck/containers/DetailWorkOrder";
import ContainerManagement from "./pages/Planner/containers/ContainerManagement";
import ViewContainerManagement from "./pages/Planner/containers/ViewContainerManagement";
import CargoTracking from "./pages/Planner/containers/CargoTracking";
import ViewCargoTracking from "./pages/Planner/containers/ViewCargoTracking";
import ViewTrainSchedule from "./pages/Planner/containers/ViewTrainSchedule";
import FinancialList from "./pages/Financial/containers/FinancialList";
import InspectionStation from "./pages/Setting/containers/InspectionStation";
import AddInspectionStation from "./pages/Setting/containers/AddInspectionStation";
import EditInspectionStation from "./pages/Setting/containers/EditinspectionStation";
import Vender from "./pages/Setting/containers/Vender";
import AddVender from "./pages/Setting/containers/AddVender";
import EditVender from "./pages/Setting/containers/EditVender";
import SaleOrderMac5Report from "./pages/Report/containers/SaleOrderMac5Report";
import ApprovalExpenseForm from "./pages/ReportPage/ApprovalExpenseForm";
import STLQuotation from "./pages/ReportPage/STLQuotation";
import STLBookingConfirmation from "./pages/ReportPage/STLBookingConfirmation";
import DailyMovementReport from "./pages/Report/containers/DailyMovementReport";
const Theme = createTheme({
  palette: {
    mode: 'light',
    // mode: 'dark',
  },
})
function App() {
  const [isInitEnvError, setInitEnvError] = useState(false);
  const [isInitEnv, setInitEnv] = useState(false);
  const history = useHistory();
  const token = localStorage.getItem("token");


  useEffect(() => {
    const loadEnv = async () => {
      try {
        await envInstants.init();
        httpClientInstants.setBaseUrl(envInstants.getConfig().baseUrl);
        setDefaultURL(envInstants.getConfig().baseUrl);
      } catch (error) {
        setInitEnvError(true);
        history.push("/login");
      } finally {
        setInitEnv(true);
      }
    };

    loadEnv();
  }, []);

  if (!isInitEnv) return "Loading...";
  if (isInitEnvError) return "Cannot load env !!!";

  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true, // won't minify CSS classnames when true
    productionPrefix: "c", // 'jss' by default
  });

  return (
    <Provider store={store} generateClassName={generateClassName}>
      <ThemeProvider theme={Theme}>
        <Router>
          {
            window.location.pathname.includes('report') ?
              <>
                <Route path='/report/quotation/:id' component={QuotationReport} />
                <Route path='/report/saleorder/:id' component={SaleOrderReport} />
                <Route path='/report/EIR/workorder/:id' component={EIRReport} />
                <Route path='/report/EIR/saleorder/:id' component={EIR_SaleorderReport} />
                <Route path='/report/containerManagement/:id' component={ContainerManagementReport} />
                <Route path='/report/containerList/:id' component={ContainerListReport} />
                {/* <Route path='/report/BookingConfirmation/:id' component={BookingConfirmationReport} /> */}
                <Route path='/report/ContainerListLoading/:id' component={ContainerListLoadingReport} />
                <Route path='/report/CargoReceipt/:id' component={CargoReceiptReport} />
                <Route path='/report/BookingDetailsReceived/:id' component={BookingDetailsReceivedReport} />
                <Route path='/report/BookingConfirmation/:id' component={STLBookingConfirmation} />
                <Route path='/report/ApprovalExpenseForm/:id' component={ApprovalExpenseForm} />
                <Route path='/report/STLQuotation/:id' component={STLQuotation} />
              </> : <div
                className="font-face-gm"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  height: "100vh", 
                }}
              >
                <React.Fragment>
                  <Switch>
                    <Route path="/login" component={Login} />

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        backgroundColor:"#F7F8FA",
                      }}
                    >

                      <SideBar />
                      <Route
                        path="/Dashboard/Dashboard"
                        component={withAuthLayout(Dashboard)}
                      />
                      <Route
                        path="/CustomerSupport/Customer"
                        component={withAuthLayout(Forwarding)}
                      />
                      <Route
                        path="/CustomerSupport/Forwarder"
                        component={withAuthLayout(Customer)}
                      />
                      <Route
                        path="/CustomerSupport/Factory"
                        component={withAuthLayout(Factory)}
                      />
                      <Route
                        path="/CustomerSupport/AddFactory"
                        component={withAuthLayout(AddFactory)}
                      />
                      <Route
                        path="/CustomerSupport/AddCustomer/:type"
                        component={withAuthLayout(AddCustomer)}
                      />
                      <Route
                        path="/CustomerSupport/SaleOrder"
                        component={withAuthLayout(SaleOrder)}
                      />
                      <Route
                        path="/CustomerSupport/AddSaleOrder"
                        component={withAuthLayout(AddSaleOrder)}
                      />
                      <Route
                        path="/CustomerSupport/DuplicateSaleOrder/:id"
                        component={withAuthLayout(AddSaleOrder)}
                      />
                      <Route
                        path="/CustomerSupport/Quotation"
                        component={withAuthLayout(Quotation)}
                      />
                      <Route
                        path="/Planner/ContainerList"
                        component={withAuthLayout(ContainerList)}
                      />
                      <Route
                        path="/Planner/ShipSchedule"
                        component={withAuthLayout(ShipSchedule)}
                      />
                      <Route
                        path="/Planner/TrainSchedule"
                        component={withAuthLayout(TrainScheduleList)}
                      />
                      <Route
                        path="/Train/TrainSchedule"
                        component={withAuthLayout(TrainScheduleList)}
                      />
                      <Route
                        path="/Train/Inboundtrain"
                        component={withAuthLayout(Inboundtrain)}
                      />
                      <Route
                        path="/Train/Outboundtrain"
                        component={withAuthLayout(Outboundtrain)}
                      />
                      <Route
                        path="/Train/EditInboundtrain/:id"
                        component={withAuthLayout(EditInboundtrain)}
                      />
                      <Route
                        path="/Train/EditOutboundtrain/:id"
                        component={withAuthLayout(EditOutboundtrain)}
                      />
                      <Route
                        path="/Planner/Planning"
                        component={withAuthLayout(Planning)}
                      />
                      <Route
                        path="/Planner/ContainerManagement"
                        component={withAuthLayout(ContainerManagement)}
                      />
                      <Route
                        path="/Planner/ViewContainerManagement/:id"
                        component={withAuthLayout(ViewContainerManagement)}
                      />
                      <Route
                        path="/Planner/Stock"
                        component={withAuthLayout(Stock)}
                      />
                      <Route
                        path="/Planner/ViewStock/:id"
                        component={withAuthLayout(ViewStock)}
                      />
                      <Route
                        path="/Planner/CargoTracking"
                        component={withAuthLayout(CargoTracking)}
                      />
                      <Route
                        path="/Planner/ViewCargoTracking/:id"
                        component={withAuthLayout(ViewCargoTracking)}
                      />
                      <Route
                        path="/ShipPlanning"
                        component={withAuthLayout(ShipPlanning)}
                      />
                      <Route
                        path="/TrainPlanning"
                        component={withAuthLayout(TrainPlanning)}
                      />
                      <Route
                        path="/TruckPlanning"
                        component={withAuthLayout(TruckPlanning)}
                      />
                      <Route
                        path="/Truck/InboundTruck"
                        component={withAuthLayout(InboundTruck)}
                      />
                      <Route
                        path="/Truck/OutboundTruck"
                        component={withAuthLayout(OutboundTruck)}
                      />
                      <Route
                        path="/Truck/EditInboundTruck/:id"
                        component={withAuthLayout(EditInboundtruck)}
                      />
                      <Route
                        path="/Truck/EditOutboundTruck/:id"
                        component={withAuthLayout(EditOutboundtruck)}
                      />
                      <Route
                        path="/Train/ContainerList"
                        component={withAuthLayout(ContainerListTrain)}
                      />
                      <Route
                        path="/Ship/Hightofwater"
                        component={withAuthLayout(Hightofwater)}
                      />
                      <Route
                        path="/Ship/ContainerList"
                        component={withAuthLayout(ContainerListShip)}
                      />
                      <Route
                        path="/Ship/ShipSchedule"
                        component={withAuthLayout(ShipSchedule)}
                      />
                      <Route
                        path="/Ship/Inbound"
                        component={withAuthLayout(Inbound)}
                      />
                      <Route
                        path="/Ship/Outbound"
                        component={withAuthLayout(Outbound)}
                      />
                      <Route
                        path="/Ship/EiditInbound/:id"
                        component={withAuthLayout(EditInbound)}
                      />
                      <Route
                        path="/Ship/EiditOutbound/:id"
                        component={withAuthLayout(EditOutbound)}
                      />

                      <Route
                        path="/Ship/ContainerTally"
                        component={withAuthLayout(ContainerTALLYList)}
                      />
                      <Route
                        path="/Ship/Cost/:voyNo/:BrageId"
                        component={withAuthLayout(Cost)}
                      />
                      <Route
                        path="/Train/Cost/:voyNo/:TrainRouteId"
                        component={withAuthLayout(TrainCost)}
                      />
                      <Route
                        path="/Ship/Plan/:voyNo"
                        component={withAuthLayout(Plan)}
                      />
                      <Route
                        path="/Train/Plan/:voyNo"
                        component={withAuthLayout(TrainPlan)}
                      />
                      <Route
                        path="/Ship/ContainerTally"
                        component={withAuthLayout(ContainerTALLYList)}
                      />
                      <Route
                        path="/Financial/Dashboard"
                        component={withAuthLayout(DashboardFinancial)}
                      />
                      <Route
                        path="/Financial/FinancialList"
                        component={withAuthLayout(FinancialList)}
                      />

                      {/* <Route
                        path="/Financial/Expense"
                        component={withAuthLayout(ExpenseList)}
                      />
                      <Route
                        path="/Financial/AddExpense"
                        component={withAuthLayout(AddExpense)}
                      />
                      <Route
                        path="/Financial/EditExpense/:id"
                        component={withAuthLayout(AddExpense)}
                      />

                      <Route
                        path="/Financial/Payment"
                        component={withAuthLayout(PaymentList)}
                      />
                      <Route
                        path="/Financial/DetailPayment/:id"
                        component={withAuthLayout(DetailPayment)}
                      /> */}
                      <Route
                        path="/ContainerRepair/RepairList"
                        component={withAuthLayout(RepairList)}
                      />
                      <Route
                        path="/ContainerRepair/RepairDetail/:id"
                        component={withAuthLayout(RepairDD)}
                      />
                      <Route
                        path="/ContainerRepair/Repair/Edit/:id"
                        component={withAuthLayout(RepairEditAndCreate)}
                      />
                      <Route
                        path="/ContainerRepair/Repair/Detail"
                        component={withAuthLayout(RepairEditAndCreate)}
                      />
                      <Route
                        path="/Truck/WorkOrder"
                        component={withAuthLayout(WorkOrder)}
                      />
                      <Route
                        path="/Truck/TruckSchedule"
                        component={withAuthLayout(TruckSchedule)}
                      />
                      <Route
                        path="/Truck/ViewTruckSchedule/:id"
                        component={withAuthLayout(ViewTruckSchedule)}
                      />
                      <Route
                        path="/Truck/AddWorkOrder"
                        component={withAuthLayout(EditWorkOrder)}
                      />
                      <Route
                        path="/Truck/ContainerList"
                        component={withAuthLayout(ContainerListTruck)}
                      />
                      <Route
                        path="/Truck/EditWorkOrder/:id"
                        component={withAuthLayout(DetailWorkOrder)}
                      />
                      <Route path="/Truck/E.I.R" component={withAuthLayout(EIR)} />
                      {/* <Route
                        path="/Truck/AddE.I.R"
                        component={withAuthLayout(EIR_Detail)}
                      /> */}
                      {/* <Route
                        path="/Truck/EditEIR/:id"
                        component={withAuthLayout(EIR_Detail)}
                      /> */}
                      <Route
                        path="/Setting/Employee"
                        component={withAuthLayout(Employee)}
                      />
                      <Route
                        path="/Setting/Transport"
                        component={withAuthLayout(Transport)}
                      />
                      <Route
                        path="/Setting/Company"
                        component={withAuthLayout(Company)}
                      />
                      <Route
                        path="/Setting/Barge"
                        component={withAuthLayout(Barge)}
                      />
                      <Route
                        path="/Setting/AddBarge"
                        component={withAuthLayout(EditBarge)}
                      />
                      <Route
                        path="/Setting/EditBarge/:id"
                        component={withAuthLayout(EditBarge)}
                      />
                      <Route
                        path="/Setting/Branch"
                        component={withAuthLayout(Branch)}
                      />
                      <Route
                        path="/Setting/Service"
                        component={withAuthLayout(ServiceList)}
                      />
                      <Route
                        path="/Setting/container"
                        component={withAuthLayout(containerPage)}
                      />
                      <Route
                        path="/Setting/Vehicle"
                        component={withAuthLayout(Vehicle)}
                      />
                      <Route
                        path="/Setting/Cost"
                        component={withAuthLayout(Costlist)}
                      />

                      <Route
                        path="/Setting/EditCost/:id"
                        component={withAuthLayout(EditCost)}
                      />

                      <Route
                        path="/Setting/AddCost"
                        component={withAuthLayout(EditCost)}
                      />

                      <Route
                        path="/Setting/Liners"
                        component={withAuthLayout(Liners)}
                      />
                      <Route
                        path="/Setting/FreightForwarder"
                        component={withAuthLayout(FreightForwarder)}
                      />
                      <Route
                        path="/Setting/Commodity"
                        component={withAuthLayout(Commodity)}
                      />
                      <Route
                        path="/Setting/Incoterms"
                        component={withAuthLayout(Incoterms)}
                      />
                      <Route
                        path="/Setting/inspectionStation"
                        component={withAuthLayout(InspectionStation)}
                      />
                      <Route
                        path="/Setting/AddInspectionStation"
                        component={withAuthLayout(AddInspectionStation)}
                      />
                      <Route
                        path="/Setting/EditInspectionStation/:id"
                        component={withAuthLayout(EditInspectionStation)}
                      />
                      <Route
                        path="/Setting/Transhipment"
                        component={withAuthLayout(Transshipment)}
                      />
                      <Route
                        path="/Setting/Depots"
                        component={withAuthLayout(Depots)}
                      />
                      <Route
                        path="/Setting/PolPod"
                        component={withAuthLayout(PolPod)}
                      />
                      <Route
                        path="/Setting/Terminal"
                        component={withAuthLayout(Terminal)}
                      />
                      <Route
                        path="/Setting/AddIncoTerms"
                        component={withAuthLayout(AddIncoTerms)}
                      />
                      <Route
                        path="/Setting/AddService"
                        component={withAuthLayout(EditService)}
                      />
                      <Route
                        path="/Setting/AddBranch"
                        component={withAuthLayout(AddBranch)}
                      />
                      <Route
                        path="/Setting/Location"
                        component={withAuthLayout(LocationList)}
                      />
                      <Route
                        path="/Setting/AddLocation"
                        component={withAuthLayout(AddLocation)}
                      />
                      <Route
                        path="/Setting/EditLocation/:id"
                        component={withAuthLayout(EditLocation)}
                      />
                      <Route
                        path="/Setting/AddTranshipment"
                        component={withAuthLayout(AddTransshipment)}
                      />
                      <Route
                        path="/Setting/AddDepots"
                        component={withAuthLayout(AddDepots)}
                      />
                      <Route
                        path="/Setting/AddCompany"
                        component={withAuthLayout(AddCompany)}
                      />
                      <Route
                        path="/Setting/AddEmployee"
                        component={withAuthLayout(AddEmployee)}
                      />
                      <Route
                        path="/Setting/AddTransport"
                        component={withAuthLayout(AddTransport)}
                      />
                      <Route
                        path="/Setting/AddPolPod"
                        component={withAuthLayout(AddPolPod)}
                      />
                      <Route
                        path="/Setting/AddTerminal"
                        component={withAuthLayout(AddTerminal)}
                      />
                      <Route
                        path="/Setting/AddContainer"
                        component={withAuthLayout(EditContainer)}
                      />
                      <Route
                        path="/Setting/AddVehicle"
                        component={withAuthLayout(EditVehicle)}
                      />
                      <Route
                        path="/Setting/AddLiners"
                        component={withAuthLayout(EditLiners)}
                      />
                      <Route
                        path="/Setting/AddFreightForwarder"
                        component={withAuthLayout(EditFreightForwarder)}
                      />
                      <Route
                        path="/Setting/AddCommodity"
                        component={withAuthLayout(EditCommodity)}
                      />
                      <Route
                        path="/Setting/AddFreightTerms"
                        component={withAuthLayout(AddFreightTerms)}
                      />
                      <Route
                        path="/Planner/AddContainerList"
                        component={withAuthLayout(AddContainerList)}
                      />
                      <Route
                        path="/Ship/detailContainerTally/:Voyage"
                        component={withAuthLayout(TallyDetail)}
                      />
                      <Route
                        path="/Train/detailContainerTally/:Voyage"
                        component={withAuthLayout(TrainTallyDetail)}
                      />
                      <Route
                        path="/CustomerSupport/AddQuotation"
                        component={withAuthLayout(EditQuotation)}
                      />
                      <Route
                        path="/Truck/EditEIR/:id"
                        component={withAuthLayout(Detail_EIR)}
                      />
                      <Route
                        path="/Truck/AddE.I.R"
                        component={withAuthLayout(Add_EIR)}
                      />
                      <Route
                        path="/Ship/CyShip/:id"
                        component={withAuthLayout(CyShip)}
                      />
                      <Route path="/Ship/Cy/:id" component={withAuthLayout(Cy)} />
                      <Route
                        path="/Planner/EditShipSchedule/:id"
                        component={withAuthLayout(EditShipSchedule)}
                      />
                      <Route
                        path="/Planner/EditTrainSchedule/:id"
                        component={withAuthLayout(EditTrainSchedule)}
                      />
                      <Route
                        path="/Planner/ViewTrainSchedule/:id"
                        component={withAuthLayout(ViewTrainSchedule)}
                      />
                      <Route
                        path="/CustomerSupport/EditCustomer/:id"
                        component={withAuthLayout(EditCustomer)}
                      />
                      <Route
                        path="/Setting/EditEmployee/:id"
                        component={withAuthLayout(EditEmployee)}
                      />
                      <Route
                        path="/Setting/EditTransport/:id"
                        component={withAuthLayout(EditTransport)}
                      />
                      <Route
                        path="/Setting/EditCompany/:id"
                        component={withAuthLayout(EditCompany)}
                      />
                      <Route
                        path="/CustomerSupport/EditQuotation/:id"
                        component={withAuthLayout(EditQuotation)}
                      />
                      <Route
                        path="/Setting/EditFreightTerms/:id"
                        component={withAuthLayout(EditFreightTerms)}
                      />
                      <Route
                        path="/CustomerSupport/EditSaleOrder/:id"
                        component={withAuthLayout(EditSaleOrder)}
                      />
                      <Route
                        path="/CustomerSupport/EditSaleOrderOld/:id"
                        component={withAuthLayout(EditSaleOrderOld)}
                      />
                      <Route
                        path="/CustomerSupport/EditFactory/:id"
                        component={withAuthLayout(EditFactory)}
                      />
                      <Route
                        path="/Setting/EditDepots/:id"
                        component={withAuthLayout(EditDepots)}
                      />
                      <Route
                        path="/Setting/EditTranshipment/:id"
                        component={withAuthLayout(EditTransshipment)}
                      />
                      <Route
                        path="/Setting/EditTerminal/:id"
                        component={withAuthLayout(EditTerminal)}
                      />
                      <Route
                        path="/Setting/EditPolPod/:id"
                        component={withAuthLayout(EditPolPod)}
                      />
                      <Route
                        path="/Setting/EditBranch/:id"
                        component={withAuthLayout(EditBranch)}
                      />
                      <Route
                        path="/Setting/EditContainer/:id"
                        component={withAuthLayout(EditContainer)}
                      />
                      <Route
                        path="/Setting/EditVehicle/:id"
                        component={withAuthLayout(EditVehicle)}
                      />
                      <Route
                        path="/Setting/EditLiners/:id"
                        component={withAuthLayout(EditLiners)}
                      />
                      <Route
                        path="/Setting/EditFreightForwarder/:id"
                        component={withAuthLayout(EditFreightForwarder)}
                      />
                      <Route
                        path="/Setting/EditCommodity/:id"
                        component={withAuthLayout(EditCommodity)}
                      />
                      <Route
                        path="/Setting/EditService/:id"
                        component={withAuthLayout(EditService)}
                      />

                      <Route
                        path="/Setting/ManagePermissions"
                        component={withAuthLayout(ManagePermissions)}
                      />

                      <Route
                        path="/Setting/SetPermissions"
                        component={withAuthLayout(SetPermissions)}
                      />
                      <Route
                        path="/Setting/Tuglist"
                        component={withAuthLayout(Tuglist)}
                      />
                      <Route
                        path="/Setting/EditTug/:id"
                        component={withAuthLayout(Edittug)}
                      />
                      <Route
                        path="/Setting/Addtug"
                        component={withAuthLayout(Edittug)}
                      />
                      <Route
                        path="/Setting/FreightTerms"
                        component={withAuthLayout(FreightTerms)}
                      />
                      <Route
                        path="/Setting/EditIcoTerms/:id"
                        component={withAuthLayout(EditIcoTerms)}
                      />
                      <Route path="/Setting/Role" component={withAuthLayout(Role)} />
                      <Route
                        path="/Setting/Package"
                        component={withAuthLayout(Package)}
                      />
                      <Route
                        path="/Setting/AddPackage"
                        component={withAuthLayout(AddPackage)}
                      />
                      <Route
                        path="/Setting/EditPackag/:id"
                        component={withAuthLayout(AddPackage)}
                      />
                      <Route
                        path="/Setting/Currency"
                        component={withAuthLayout(Currency)}
                      />
                      <Route
                        path="/Setting/EditCurrency/:id"
                        component={withAuthLayout(EditCurrency)}
                      />
                      <Route
                        path="/Setting/AddCurrency"
                        component={withAuthLayout(EditCurrency)}
                      />
                      <Route
                        path="/Setting/Country"
                        component={withAuthLayout(Country)}
                      />
                      <Route
                        path="/Setting/EditCountry/:id"
                        component={withAuthLayout(EditCountry)}
                      />
                      <Route
                        path="/Setting/TrainRoute"
                        component={withAuthLayout(TrainRoute)}
                      />
                      <Route
                        path="/Setting/AddTrainroute"
                        component={withAuthLayout(AddTrainroute)}
                      />
                      <Route
                        path="/Setting/EditTrainroute/:id"
                        component={withAuthLayout(EditTrainroute)}
                      />
                      <Route
                        path="/Setting/AddCountry"
                        component={withAuthLayout(EditCountry)}
                      />
                      <Route
                        path="/Setting/Vender"
                        component={withAuthLayout(Vender)}
                      />
                      <Route
                        path="/Setting/AddVender"
                        component={withAuthLayout(AddVender)}
                      />
                      <Route
                        path="/Setting/EditVender/:id"
                        component={withAuthLayout(EditVender)}
                      />
                      <Route
                        path="/Report"
                        component={withAuthLayout(Report)}
                      />
                      <Route
                        path="/EmptyContainer"
                        component={withAuthLayout(ReportEmpty)}
                      />
                      <Route
                        path="/LadenContainer"
                        component={withAuthLayout(ReportLaden)}
                      />
                      <Route
                        path="/Expense"
                        component={withAuthLayout(ReportExpense)}
                      />
                      <Route
                        path="/AdvancePayment"
                        component={withAuthLayout(ReportAdvancePayment)} />
                      <Route
                        path="/SaleOrderCostReport"
                        component={withAuthLayout(SaleOrderCostReport)}
                      />
                      <Route
                        path="/TrainCostReport"
                        component={withAuthLayout(TrainCostReport)}
                      />
                      <Route
                        path="/ShipCostReport"
                        component={withAuthLayout(ShipCostReport)}
                      />
                      <Route
                        path="/ReportRevenue"
                        component={withAuthLayout(ReportRevenue)}
                      />
                      <Route
                        path="/SaleOrderMAC-5Report"
                        component={withAuthLayout(SaleOrderMac5Report)}
                      />
                      <Route
                        path="/DailyMovement-Report"
                        component={withAuthLayout(DailyMovementReport)}
                      />
                      <Route exact path="/">
                        {localStorage.getItem("token") ? (
                          <Redirect to="/CustomerSupport/Forwarder" />
                        ) : (
                          <Redirect to="/login" />
                        )}
                      </Route>
                    </div>
                  </Switch>
                </React.Fragment>
              </div>}

        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
